import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';
import { GetShootingTypeResponse } from '../../../../types/StudioFileManager';

const GetShootingTypes = (): Promise<GetShootingTypeResponse[]> => {
    return request({
        url: ApiURL.Query.StudioQueryURLs.StudioFileManagerQueryURL.GetShootingTypes,
        method: RequestType.GET,
    });
};

export const StudioFileManagerQuery = {
    GetShootingTypes,
};
